import React, {  useState } from "react";
import CampanaCard from "./CampanaCard";
import styled from "styled-components";
import {
    PrimaryActionButtonForPage
} from "../../styledComponents/styledComponents";
import RegistrarCampana from "../crearEditar/RegistrarCampana";
import ModalEnabled from "../../../../components/modalComponents/ModalEnabled";

const Sidebar = styled.div`
  width: 320px;
  border-right: 1px solid #ddd;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  padding: 12px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

const ScrollContainer = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 10px;

  scrollbar-width: thin;
  scrollbar-color: #bbb transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #bbb;
    border-radius: 4px;
  }
`;



export default function ListarCampanas({
                                           campanas,
                                           campanaSeleccionada,
                                           onSelect,
                                           refreshListarCampanas,
                                           puedeCrearCampana
                                       }) {
    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

    return (<>

            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={refreshListarCampanas}
            />
            <Sidebar>
                <Header >
                    <div>Campañas</div>
                    {puedeCrearCampana &&
                        <div className="mr-2">
                            <PrimaryActionButtonForPage onClick={() =>
                                setModalEnabled({
                                    isEnable: true,
                                    component: RegistrarCampana,
                                    data: {}
                                })
                            }>
                                Nuevo
                            </PrimaryActionButtonForPage>
                        </div>
                    }

                </Header>

                <ScrollContainer>
                    {campanas.map((campana) => (
                        <CampanaCard
                            key={campana.IdCampana}
                            campana={campana}
                            isSelected={campanaSeleccionada?.IdCampana === campana.IdCampana}
                            onClick={() => onSelect(campana)}
                            refreshListarCampanas={refreshListarCampanas}
                            setModalEnabled={setModalEnabled}
                        />
                    ))}
                </ScrollContainer>
            </Sidebar>
    </>

    );
}
